/** Nombres de ejercicios del catálogo (españo natural, uso en gimnasio) */
export const EXERCISE_STANDARD_ES = {
  'exercise.standard.burpee': 'Burpee',
  'exercise.standard.lunges': 'Zancadas sin carga',
  'exercise.standard.bench_press_barbell': 'Press de banca con barra',
  'exercise.standard.incline_bench_press_barbell': 'Press de banca inclinado con barra',
  'exercise.standard.decline_bench_press_barbell': 'Press de banca declinado con barra',
  'exercise.standard.bench_press_dumbbell': 'Press de banca con mancuernas',
  'exercise.standard.incline_bench_press_dumbbell': 'Press inclinado con mancuernas',
  'exercise.standard.overhead_press_barbell': 'Press militar de pie con barra',
  'exercise.standard.push_ups': 'Flexiones',
  'exercise.standard.chest_dips': 'Fondos en paralelas',
  'exercise.standard.plank': 'Plancha',
  'exercise.standard.pull_ups': 'Dominadas',
  'exercise.standard.calf_raises_standing': 'Elevación de gemelos de pie',
  'exercise.standard.squat_bodyweight': 'Sentadillas sin peso',
  'exercise.standard.squat_barbell': 'Sentadilla trasera con barra',
  'exercise.standard.lateral_raise_dumbbell': 'Elevaciones laterales con mancuernas',
  'exercise.standard.tricep_pushdown': 'Extensión de tríceps en polea baja',
  'exercise.standard.barbell_curl': 'Curl de bíceps con barra',
  'exercise.standard.crunches': 'Abdominales',
  'exercise.standard.deadlift': 'Peso muerto',
  'exercise.standard.lat_pulldown': 'Jalón al pecho',
  'exercise.standard.dumbbell_row': 'Remo con mancuerna',
  'exercise.standard.chin_up': 'Dominadas supinas',
  'exercise.standard.lat_pulldown_reverse_grip': 'Jalón al pecho agarre supino',
  'exercise.standard.lat_pulldown_behind_neck': 'Jalón tras nuca',
  'exercise.standard.barbell_row_bent_over': 'Remo pendiente con barra',
  'exercise.standard.t_bar_row': 'Remo en barra T',
  'exercise.standard.seated_cable_row': 'Remo en polea sentado',
  'exercise.standard.one_arm_dumbbell_row': 'Remo con mancuerna a una mano',
  'exercise.standard.hyperextension': 'Hiperextensión de lumbares',
  'exercise.standard.shoulder_press_dumbbell_seated': 'Press de hombros sentado con mancuernas',
  'exercise.standard.shoulder_press_barbell_seated': 'Press militar sentado con barra',
  'exercise.standard.arnold_press': 'Press Arnold',
  'exercise.standard.shoulder_press_machine': 'Press de hombros en máquina',
  'exercise.standard.front_raise_dumbbell': 'Elevación frontal con mancuernas',
  'exercise.standard.lateral_raise_swing': 'Elevaciones laterales con mancuernas (con inercia)',
  'exercise.standard.rear_delt_fly_bent_over': 'Pájaros posteriores en inclinación',
  'exercise.standard.upright_row_barbell': 'Remo al mentón con barra',
  'exercise.standard.dumbbell_curl_standing': 'Curl de bíceps de pie con mancuernas',
  'exercise.standard.dumbbell_curl_seated': 'Curl de bíceps sentado con mancuernas',
  'exercise.standard.hammer_curl': 'Curl martillo',
  'exercise.standard.preacher_curl': 'Curl en banco Scott',
  'exercise.standard.cable_curl_seated': 'Curl en polea alta sentado',
  'exercise.standard.close_grip_bench_press': 'Press de banca agarre cerrado',
  'exercise.standard.skull_crusher': 'Press francés',
  'exercise.standard.bench_dip': 'Fondos en banco',
  'exercise.standard.overhead_tricep_extension_dumbbell': 'Extensión de tríceps con mancuerna',
  'exercise.standard.pistol_squat': 'Sentadilla pistola',
  'exercise.standard.lunge_dumbbell': 'Zancadas con mancuernas',
  'exercise.standard.lunge_barbell': 'Zancadas con barra',
  'exercise.standard.leg_press': 'Prensa de piernas',
  'exercise.standard.hack_squat': 'Hack squat',
  'exercise.standard.squat_smith': 'Sentadilla en multipower',
  'exercise.standard.hack_squat_smith': 'Hack squat en multipower',
  'exercise.standard.romanian_deadlift': 'Peso muerto rumano',
  'exercise.standard.stiff_leg_deadlift': 'Peso muerto con piernas rígidas',
  'exercise.standard.calf_raise_seated': 'Gemelos en máquina sentado',
  'exercise.standard.reverse_crunches': 'Abdominales inversos',
  'exercise.standard.hanging_leg_raise': 'Elevación de piernas colgado',
  'exercise.standard.russian_twist': 'Giros rusos',
  'exercise.standard.stomach_vacuum': 'Vacío abdominal',
  'exercise.standard.side_plank': 'Plancha lateral',
  'exercise.standard.high_knees': 'Rodillas al pecho',
  'exercise.standard.jump_rope': 'Cuerda para saltar',
  'exercise.standard.burpee_jump': 'Burpee con salto',
  'exercise.standard.boxer_shuffle': 'Saltos de boxeador',
  'exercise.standard.jump_rope_singles': 'Saltos básicos con cuerda',
  'exercise.standard.sprint': 'Sprint',
  'exercise.standard.stair_climb': 'Subida de escaleras',
};
